import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Lackfertighaus - Professionelle Ausbauarbeiten</title>
        <meta name="description" content="Lackfertighaus - Professionelle Ausbauarbeiten und Finishing-Lösungen in Deutschland. Hochwertige Handwerkskunst für Ihr Zuhause." />
        <link href="https://lackfertighaus.com/privacy-policy" rel="canonical"/>
      </Helmet>

      <div className="policy-page">
      <div className="policy-container">
        <h1>Datenschutzerklärung</h1>
        <p className="last-updated">Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}</p>

        <section>
          <h2>1. Einleitung</h2>
          <p>
            Willkommen bei Lackfertighaus. Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
            Diese Datenschutzerklärung informiert Sie darüber, wie wir Ihre personenbezogenen Daten 
            erheben, verarbeiten und nutzen, wenn Sie unsere Website besuchen oder unsere Dienstleistungen 
            im Bereich professioneller Ausbauarbeiten und Finishing-Lösungen in Anspruch nehmen.
          </p>
        </section>

        <section>
          <h2>2. Verantwortliche Stelle</h2>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:
          </p>
          <p>
            <strong>Lackfertighaus</strong><br />
            Deutschland<br />
            E-Mail: lackfertighaus@hotmail.com
          </p>
        </section>

        <section>
          <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
          
          <h3>3.1 Besuch unserer Website</h3>
          <p>
            Bei jedem Aufruf unserer Website erfasst unser System automatisiert Daten und Informationen 
            vom Computersystem des aufrufenden Rechners. Folgende Daten werden dabei erhoben:
          </p>
          <ul>
            <li>Informationen über den Browsertyp und die verwendete Version</li>
            <li>Das Betriebssystem des Nutzers</li>
            <li>Den Internet-Service-Provider des Nutzers</li>
            <li>Die IP-Adresse des Nutzers</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Websites, von denen das System des Nutzers auf unsere Website gelangt</li>
            <li>Websites, die vom System des Nutzers über unsere Website aufgerufen werden</li>
          </ul>

          <h3>3.2 Kontaktformular und E-Mail-Kontakt</h3>
          <p>
            Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben 
            aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks 
            Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. 
            Diese Daten umfassen typischerweise:
          </p>
          <ul>
            <li>Name und Vorname</li>
            <li>E-Mail-Adresse</li>
            <li>Telefonnummer (optional)</li>
            <li>Nachrichteninhalt</li>
            <li>Projektdetails und spezifische Anforderungen</li>
          </ul>
        </section>

        <section>
          <h2>4. Zweck der Datenverarbeitung</h2>
          
          <h3>4.1 Bereitstellung der Website</h3>
          <p>
            Die Verarbeitung der bei jedem Aufruf unserer Website erhobenen Daten ist notwendig, 
            um die Auslieferung der Website zu ermöglichen und die dauerhafte Funktionsfähigkeit 
            und Sicherheit unserer IT-Systeme zu gewährleisten.
          </p>

          <h3>4.2 Kontaktaufnahme und Kundenbetreuung</h3>
          <p>
            Die Verarbeitung Ihrer personenbezogenen Daten aus dem Kontaktformular erfolgt 
            ausschließlich zur Bearbeitung Ihrer Anfrage. Bei Kontaktaufnahme per E-Mail liegt 
            hieran auch das erforderliche berechtigte Interesse an der Verarbeitung der Daten. 
            Dies umfasst:
          </p>
          <ul>
            <li>Beantwortung Ihrer Anfragen zu unseren Dienstleistungen</li>
            <li>Erstellung von Angeboten für Ausbauarbeiten</li>
            <li>Projektplanung und -koordination</li>
            <li>Nachbetreuung und Qualitätssicherung</li>
          </ul>
        </section>

        <section>
          <h2>5. Rechtsgrundlage der Verarbeitung</h2>
          <p>
            Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten ist:
          </p>
          <ul>
            <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</li>
            <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
            <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)</li>
          </ul>
        </section>

        <section>
          <h2>6. Cookies und Tracking-Technologien</h2>
          
          <h3>6.1 Verwendung von Cookies</h3>
          <p>
            Unsere Website verwendet Cookies. Cookies sind Textdateien, die im Internetbrowser bzw. 
            vom Internetbrowser auf dem Computersystem des Nutzers gespeichert werden. Wir verwenden:
          </p>
          <ul>
            <li><strong>Technisch notwendige Cookies:</strong> Diese sind für die Grundfunktionen der Website erforderlich</li>
            <li><strong>Funktionale Cookies:</strong> Diese ermöglichen verbesserte Funktionalität und Personalisierung</li>
            <li><strong>Analyse-Cookies:</strong> Diese helfen uns, die Nutzung der Website zu analysieren</li>
          </ul>

          <h3>6.2 Google Analytics</h3>
          <p>
            Diese Website nutzt Google Analytics, einen Webanalysedienst der Google LLC. 
            Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website ermöglichen. 
            Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden 
            in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.
          </p>

          <h3>6.3 Facebook Pixel</h3>
          <p>
            Wir verwenden den Facebook-Pixel von Facebook Inc. Dieser ermöglicht es uns, das Verhalten 
            von Nutzern nachzuverfolgen, nachdem diese durch Klick auf eine Facebook-Werbeanzeige auf 
            unsere Website weitergeleitet wurden.
          </p>
        </section>

        <section>
          <h2>7. Weitergabe von Daten</h2>
          <p>
            Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden 
            aufgeführten Zwecken findet nicht statt. Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:
          </p>
          <ul>
            <li>Sie Ihre ausdrückliche Einwilligung dazu erteilt haben (Art. 6 Abs. 1 lit. a DSGVO)</li>
            <li>Die Weitergabe zur Erfüllung eines Vertrages erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO)</li>
            <li>Eine gesetzliche Verpflichtung zur Weitergabe besteht (Art. 6 Abs. 1 lit. c DSGVO)</li>
            <li>Die Weitergabe zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist</li>
          </ul>
        </section>

        <section>
          <h2>8. Datensicherheit</h2>
          <p>
            Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) 
            in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. 
            Zusätzlich sichern wir unsere Website und sonstigen Systeme durch technische und organisatorische 
            Maßnahmen gegen Verlust, Zerstörung, Zugriff, Veränderung oder Verbreitung Ihrer Daten durch 
            unbefugte Personen.
          </p>
        </section>

        <section>
          <h2>9. Speicherdauer</h2>
          <p>
            Wir speichern personenbezogene Daten nur so lange, wie dies für die Erfüllung der verfolgten 
            Zwecke notwendig ist oder gesetzliche Aufbewahrungsfristen bestehen. Nach Zweckfortfall oder 
            Ablauf dieser Fristen werden die entsprechenden Daten routinemäßig und nach den gesetzlichen 
            Vorschriften gesperrt oder gelöscht.
          </p>
        </section>

        <section>
          <h2>10. Ihre Rechte als betroffene Person</h2>
          <p>
            Sie haben nach der DSGVO folgende Rechte:
          </p>
          <ul>
            <li><strong>Auskunftsrecht (Art. 15 DSGVO):</strong> Sie haben das Recht, Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen</li>
            <li><strong>Berichtigungsrecht (Art. 16 DSGVO):</strong> Sie haben das Recht, unverzüglich die Berichtigung unrichtiger Daten zu verlangen</li>
            <li><strong>Löschungsrecht (Art. 17 DSGVO):</strong> Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen</li>
            <li><strong>Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen</li>
            <li><strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, Ihre Daten in einem strukturierten Format zu erhalten</li>
            <li><strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie haben das Recht, der Verarbeitung Ihrer Daten zu widersprechen</li>
            <li><strong>Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO):</strong> Sie haben das Recht, eine erteilte Einwilligung jederzeit zu widerrufen</li>
            <li><strong>Beschwerderecht (Art. 77 DSGVO):</strong> Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren</li>
          </ul>
        </section>

        <section>
          <h2>11. Automatisierte Entscheidungsfindung</h2>
          <p>
            Wir nutzen keine automatisierte Entscheidungsfindung einschließlich Profiling gemäß 
            Art. 22 DSGVO zur Begründung und Durchführung der Geschäftsbeziehung.
          </p>
        </section>

        <section>
          <h2>12. Externe Links</h2>
          <p>
            Unsere Website kann Links zu Websites anderer Anbieter enthalten. Wir haben keinen Einfluss 
            darauf, dass diese Anbieter die Datenschutzbestimmungen einhalten. Bitte informieren Sie sich 
            auf den verlinkten Websites über den dortigen Umgang mit Ihren Daten.
          </p>
        </section>

        <section>
          <h2>13. Änderungen dieser Datenschutzerklärung</h2>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen 
            rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der 
            Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
          </p>
        </section>

        <section>
          <h2>14. Kontakt bei Datenschutzfragen</h2>
          <p>
            Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail an: 
            lackfertighaus@hotmail.com
          </p>
        </section>
      </div>
    </div>
  
    </>);
};

export default PrivacyPolicy;